import { render, staticRenderFns } from "./PictureDisplay.vue?vue&type=template&id=41ef7106&scoped=true"
import script from "./PictureDisplay.vue?vue&type=script&lang=js"
export * from "./PictureDisplay.vue?vue&type=script&lang=js"
import style0 from "./PictureDisplay.vue?vue&type=style&index=0&id=41ef7106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ef7106",
  null
  
)

export default component.exports